import React from "react";
import PropTypes from "prop-types";
import { Divider, Grid, Segment, Responsive } from "semantic-ui-react";
import { Title, InText, ImageItem } from "../../components";

const Base = ({
  baseData = [],
  totallikes,
  totalpoints,
  isdisplayemail,
  ispage,
  openphotomodal,
  openeditpasswordModal,
  isenableedit,
}) => {
  return (
    <div style={{ width: "100%" }}>
      {baseData &&
        baseData.length > 0 &&
        baseData.map((activity, index) => (
          <div className="basedatarealtor">
            <Grid>
              <Grid.Row key={index}>
                <Grid.Column width={5}>
                  {activity.userimage ? (
                    <ImageItem
                      source={activity.userimage}
                      size="medium"
                      className="image_marign"
                      alt="User Image"
                      title="User Image"
                    />
                  ) : (
                    <ImageItem
                      source={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/userdefault.png`}
                      size="medium"
                      alt="User Image"
                      title="User Image"
                    />
                  )}
                  {isenableedit && (
                    <>
                      <br />
                      <span className="add_edit_photo" onClick={openphotomodal}>
                        Add / Edit Photo
                      </span>
                    </>
                  )}
                </Grid.Column>
                <Grid.Column width={11}>
                  <Title name={`${activity.firstName} ${activity.lastName}`} />
                  <Segment basic className="comman_seg">
                    <Title name="Helpful Votes:" floated="left" size="small" />
                    <InText name={totallikes} floated="left" />
                    <Title
                      name="Total Points Earned:"
                      floated="left"
                      size="small"
                    />
                    <InText name={totalpoints} floated="left" />
                  </Segment>
                  {ispage != "profileuser" && (
                    <>
                      {/* {activity.email ? (
                      <Segment
                        basic
                        className={`comman_seg ${
                          activity.email ? "realestatefirms_email" : ""
                        }`}
                      >
                        <Title name="Email:" floated="left" size="small" />
                        <InText name={activity.email} floated="left" />
                      </Segment>
                    ) : null} */}
                      {/* {activity.phone ? (
                      <Segment
                        basic
                        className={`comman_seg ${
                          activity.phone ? "realestatefirms_phone" : ""
                        }`}
                      >
                        <Title
                          name="Phone Number:"
                          floated="left"
                          size="small"
                        />
                        <InText name={activity.phone} floated="left" />
                      </Segment>
                    ) : null} */}
                      {activity.realEstateFirm ? (
                        <Segment
                          basic
                          className={`comman_seg ${
                            activity.realEstateFirm
                              ? "realestatefirms_realtor"
                              : ""
                          }`}
                        >
                          <Title
                            name="Real Estate Firm :"
                            floated="left"
                            size="small"
                          />
                          <InText
                            name={activity.realEstateFirm}
                            floated="left"
                          />
                        </Segment>
                      ) : null}
                      {activity.license ? (
                        <Segment
                          basic
                          className={`comman_seg ${
                            activity.license ? "realestatefirms_license" : ""
                          }`}
                        >
                          <Title
                            name="RE License # :"
                            floated="left"
                            size="small"
                          />
                          <InText name={activity.license} floated="left" />
                        </Segment>
                      ) : null}
                      {/* {activity.head4 ? (
                      <Segment basic className="comman_seg">
                        <Title
                          name="Phone Number :"
                          floated="left"
                          size="small"
                        />
                        <InText name={activity.phone} floated="left" />
                      </Segment>
                    ) : null} */}
                      {/* <Segment basic className="comman_seg">
                      <Title name="Password :" floated="left" size="small" />
                      <InText name="xxxxxxxx" floated="left" />
                      {isenableedit && (
                        <span
                          onClick={openeditpasswordModal}
                          style={{
                            fontSize: "15px",
                            marginLeft: "10px",
                            color: "#2185d0",
                            cursor: "pointer",
                            marginTop: "8px",
                            display: "inline-block",
                          }}
                        >
                          Edit password
                        </span>
                      )}
                    </Segment> */}
                    </>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        ))}
      <div>
        {/* <Responsive maxWidth={767}> */}
        {baseData &&
          baseData.length > 0 &&
          baseData.map((activity, index) => (
            <Grid style={{ minHeight: "60px" }}>
              <Grid.Row key={index} style={{ display: "flex" }}>
                <Grid.Column mobile={8}>
                  {activity.userimage ? (
                    <ImageItem
                      source={activity.userimage}
                      size="medium"
                      alt="User Image"
                      title="User Image"
                    />
                  ) : (
                    <ImageItem
                      source={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/userdefault.png`}
                      size="medium"
                      alt="User Image"
                      title="User Image"
                    />
                  )}
                </Grid.Column>
                <Grid.Column mobile={8} className={"realtor_title"}>
                  <Title name={`${activity.firstName} ${activity.lastName}`} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ clear: "both" }} className="title_mob_val">
                <Grid.Column mobile={16} tablet={8} computer={9}>
                  <Segment basic className="comman_seg spe_data_mar">
                    <Title name="Likes Received:" floated="left" size="small" />
                    <InText
                      name={activity.likes}
                      floated="left"
                      className="comman_seg_value "
                    />
                  </Segment>
                  <Segment basic className="comman_seg">
                    <Title
                      name="Total Points Earned:"
                      floated="left"
                      size="small"
                    />
                    <InText
                      name={activity.points}
                      floated="left"
                      className="comman_seg_value"
                    />
                  </Segment>
                  {activity.email ? (
                    <Segment basic className="comman_seg">
                      <Title name="Email:" floated="left" size="small" />
                      <InText
                        name={activity.email}
                        floated="left"
                        className="comman_seg_value"
                      />
                    </Segment>
                  ) : null}
                  {activity.realEstateFirm ? (
                    <Segment basic className="comman_seg">
                      <Title
                        name="Real Estate Firm :"
                        floated="left"
                        size="small"
                      />
                      <InText
                        name={activity.realEstateFirm}
                        floated="left"
                        className="comman_seg_value"
                      />
                    </Segment>
                  ) : null}
                  {activity.license ? (
                    <Segment basic className="comman_seg">
                      <Title
                        name="RE License # :"
                        floated="left"
                        size="small"
                      />
                      <InText
                        name={activity.license}
                        floated="left"
                        className="comman_seg_value"
                      />
                    </Segment>
                  ) : null}
                  {activity.head4 ? (
                    <Segment basic className="comman_seg">
                      <Title
                        name="Phone Number :"
                        floated="left"
                        size="small"
                      />
                      <InText
                        name={activity.phone}
                        floated="left"
                        className="comman_seg_value"
                      />
                    </Segment>
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ))}
        {/* </Responsive> */}
      </div>
    </div>
  );
};

Base.propTypes = {
  baseData: PropTypes.array,
};

export default Base;
